import {StorageLocation} from "../models/StorageLocation";
import {getToken} from "../auth/service/authService";
import axios from "axios";
import {BackendUrl} from "../util/config";

const API_BASE = BackendUrl;

export async function fetchStorageLocationsByOrgId(orgId: string): Promise<StorageLocation[]> {
    const token = getToken();
    const response = await axios.get<StorageLocation[]>(
        `${API_BASE}/storage-locations/by-org/${orgId}`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );
    return response.data;
}

export async function createStorageLocation(
    orgId: string,
    name: string,
    description: string
): Promise<void> {
    const token = getToken();
    await axios.post(
        `${API_BASE}/storage-locations?organizationId=${orgId}`,
        {
            name,
            description,
        },
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );
}

export async function deleteStorageLocation(
    storageLocationId: string,
): Promise<void> {
    const token = getToken();
    await axios.delete(
        `${API_BASE}/storage-locations/${storageLocationId}`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );
}